"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.219 3.414C2.596 2.602 3.432 2 4.492 2h7.016c1.06 0 1.897.602 2.274 1.414.38.817.287 1.841-.463 2.603l-3.24 3.292a.12.12 0 0 0-.037.08v2.65C10.042 13.16 9.087 14 8 14s-2.041-.839-2.041-1.962V9.39a.12.12 0 0 0-.037-.08l-3.24-3.293a2.285 2.285 0 0 1-.463-2.603m1.27.59a.89.89 0 0 0 .19 1.03l3.24 3.293c.278.282.44.661.44 1.063v2.648c0 .27.246.562.641.562s.642-.291.642-.562V9.39c0-.402.161-.78.439-1.063l3.24-3.292a.89.89 0 0 0 .191-1.031c-.154-.332-.504-.604-1.004-.604H4.492c-.5 0-.85.272-1.004.604",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterIcon16.js.map